import {useState} from 'react';
import {
  MDXEditor, 
  UndoRedo,
  BoldItalicUnderlineToggles,
  ListsToggle,
  listsPlugin,
  // CreateLink,
  // linkPlugin,
  // linkDialogPlugin,
  toolbarPlugin
} from '@mdxeditor/editor';
import '@mdxeditor/editor/style.css';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';

const MarkdownInput = ({
  defaultValue,
  onChange,
  className,
  disabled,
  ...props
}) => {
  let [markdown, setMarkdown] = useState(defaultValue);
  const onMarkdownChange = newMarkdown => {
    setMarkdown(newMarkdown);
    if (onChange) onChange({target: {value: newMarkdown}}, newMarkdown);
  };
  return (
    <MDXEditor
      markdown={markdown}
      className={className}
      disabled={disabled}
      onChange={onMarkdownChange}
      plugins={[ 
        toolbarPlugin({
          toolbarClassName: 'my-classname',
          toolbarContents: () => (
            <>
              <UndoRedo />
              <BoldItalicUnderlineToggles />
              {/* <CreateLink /> */}
              <ListsToggle />
            </>
          )
        }),
        // linkPlugin(),
        // linkDialogPlugin(),
        listsPlugin(),
    ]}
    />
  );

};

const MarkdownEditor = ({
  defaultValue = '',
  disabled = false,
  fullWidth = false,
  className = 'markdown-editor',
  onChange = null,
  footerContent = null,
  isLoading = false,
} = {}) => {

  return (
    <Box 
      width={fullWidth ? '100%' : 'auto'}
      style={{
        border: disabled ? 'none' : '1px solid #ccc',
        borderRadius: '4px',
        backgroundColor: disabled ? '#f5f5f5' : 'white',
      }}
    >
      {
        isLoading
        ? <Box style={{minHeight: '96px', backgroundColor: '#f5f5f5', borderRadius: '4px'}}>
          <Stack 
            direction='row' 
            justifyContent='center' 
            alignItems='center' 
            style={{height: '96px'}}
          >
            <CircularProgress />
          </Stack>
        </Box>
        : <MarkdownInput
            defaultValue={defaultValue}
            disabled={disabled}
            className={className}
            onChange={onChange}
          />
      }
      {footerContent &&
        <Box 
          mt={1} 
          style={{backgroundColor: '#f9f9f9', borderTop: '1px solid #eee'}}
        >
          {footerContent}
        </Box>
      }
    </Box>
  );
};

export default MarkdownEditor;